import { useEffect, useState } from 'react';
import { db } from '../lib/firebase';
import { collection, query, orderBy, onSnapshot, addDoc, serverTimestamp } from 'firebase/firestore';

const ICONS = { food: '🍔', drink: '🧋', transport: '🚗', movie: '🎬', shop: '🛍️', other: '💸' };

function guessIcon(name = '') {
  const n = name.toLowerCase();
  if (/food|eat|makan|lunch|dinner|breakfast|burger|pizza|nasi/.test(n)) return '🍔';
  if (/drink|bubble|boba|coffee|teh|milo/.test(n)) return '🧋';
  if (/grab|uber|bus|train|toll|parking|petrol/.test(n)) return '🚗';
  if (/movie|cinema|ticket|show/.test(n)) return '🎬';
  if (/shop|mall|buy|beli/.test(n)) return '🛍️';
  return '💸';
}

export default function ExpenseScreen({ user, userData }) {
  const [expenses, setExpenses] = useState([]);
  const [modal, setModal]       = useState(false);
  const [name, setName]         = useState('');
  const [amount, setAmount]     = useState('');
  const [paidBy, setPaidBy]     = useState('');
  const [split, setSplit]       = useState('equal');

  useEffect(() => {
    const q = query(collection(db, 'expenses'), orderBy('timestamp', 'desc'));
    return onSnapshot(q, snap => {
      const e = [];
      snap.forEach(d => e.push({ id: d.id, ...d.data() }));
      setExpenses(e);
    });
  }, []);

  async function submit() {
    if (!name || !amount) return;
    await addDoc(collection(db, 'expenses'), {
      name,
      amount:     parseFloat(amount),
      paidBy:     user.uid,
      paidByName: paidBy || userData.displayName,
      split,
      timestamp:  serverTimestamp(),
    });
    setName(''); setAmount(''); setPaidBy(''); setSplit('equal');
    setModal(false);
  }

  const total = expenses.reduce((s, e) => s + (e.amount || 0), 0);

  return (
    <div className="screen" style={{ position: 'relative' }}>
      <div className="screen-header">
        <div className="screen-title">expenses 💸</div>
      </div>

      <div className="scroll-area">
        {/* Total card */}
        <div className="card" style={{ marginBottom: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>total spent</div>
          <div style={{ fontSize: 32, fontWeight: 700, color: 'var(--amber)' }}>
            RM {total.toFixed(2)}
          </div>
        </div>

        {expenses.length === 0 && (
          <div style={{ textAlign: 'center', color: 'var(--text-muted)', marginTop: 40, fontSize: 14 }}>
            no expenses yet
          </div>
        )}

        {expenses.map(e => (
          <div key={e.id} className="expense-row">
            <div className="expense-icon">{guessIcon(e.name)}</div>
            <div>
              <div className="expense-name">{e.name}</div>
              <div className="expense-meta">paid by {e.paidByName} · {e.split} split</div>
            </div>
            <div className="expense-amount">RM {Number(e.amount).toFixed(2)}</div>
          </div>
        ))}
      </div>

      <button className="fab" onClick={() => setModal(true)}>
        <i className="ti ti-plus" />
      </button>

      {modal && (
        <div className="modal-backdrop" onClick={() => setModal(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" />
            <div className="modal-title">add expense</div>
            <input className="modal-input" placeholder="what for?" value={name} onChange={e => setName(e.target.value)} />
            <input className="modal-input" placeholder="amount (RM)" type="number" value={amount} onChange={e => setAmount(e.target.value)} />
            <input className="modal-input" placeholder="paid by (name)" value={paidBy} onChange={e => setPaidBy(e.target.value)} />
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 8 }}>split</div>
              <div style={{ display: 'flex', gap: 8 }}>
                {['equal', 'you', 'them'].map(s => (
                  <button key={s} className={`split-chip${split === s ? ' selected' : ''}`} onClick={() => setSplit(s)}>{s}</button>
                ))}
              </div>
            </div>
            <button className="btn-primary" onClick={submit}>add</button>
          </div>
        </div>
      )}
    </div>
  );
}
